const searchItem = (item) =>
	`<a href="${item.url}" class="flex flex-row gap-8">
    <img
      alt="${item.title}"
      class="object-contain rounded-theme"
      height="218"
      width="164"
      src="${item.image}"
      />
    <div class="flex flex-col items-start justify-center">
     <h4 class="text-body-small">
        ${item.title}
      </h4>
      <p class="mb-0">${item.vendor}</p>
      <p>${item.price}</p>
    </div>
    </a>`.trim();

export { searchItem };
